import React from "react";

const styles = {
    overlay: {
        position: "fixed",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        top: 0,
        left: 0,
        zIndex: 9999,
        minHeight: "100vh",
        width: "100vw",
        backgroundColor: "rgba(0,0,0,0.4)",
    },
    modal: {
        position: "relative",
        backgroundColor: "var(--color-background)",
        borderRadius: "12px",
        width: "clamp(320px, 50%, 640px)",
        padding: "20px",
        textAlign: "center",
        boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
    },
    header: {
        backgroundColor: "var(--color-primary)",
        color: "var(--color-background)",
        fontSize: "clamp(0.5rem, 1.5rem, 2vh)",
        fontWeight: "bold",
        padding: "12px",
        borderTopLeftRadius: "12px",
        borderTopRightRadius: "12px",
        margin: "-20px -20px 20px -20px",
    },
    text: {
        color: "var(--color-text)",
        fontSize: "clamp(0.5rem, 1.5rem, 2vh)",
        fontWeight: "semibold",
        marginTop: "10px",
    },
    buttonsContainer: {
        display: "flex",
        justifyContent: "space-between",
        marginTop: "20px",
    },
    volverButton: {
        fontSize: "clamp(0.5rem, 1.5rem, 2vh)",
        padding: "8px 16px",
        backgroundColor: "var(--color-inactive)",
        cursor: "pointer",
        border: "none",
        borderRadius: "9999px"
    },
    volverHover: {
        backgroundColor: "#d1d5db",
    },
    salirButton: {
        fontSize: "clamp(0.5rem, 1.5rem, 2vh)",
        padding: "8px 16px",
        cursor: "pointer",
        transition: "background-color 0.3s",
        backgroundColor: "#dc2626",
        color: "var(--color-background)",
        border: "none",
        borderRadius: "9999px"
    },
    salirHover: {
        backgroundColor: "#b91c1c",
    },
};

function ModalConfirmar({ isOpen, onClose, onConfirm }) {
    if (!isOpen) return null;

    return (
        <div style={styles.overlay}>
        <div style={styles.modal}>
            <h3 style={styles.header}>Salir de la fila</h3>
            <p style={styles.text}>
            ¿Segur@ que quieres salir de la fila?
            <br />
            Si lo haces perderás tu turno para ser atendid@
            </p>

            <div style={styles.buttonsContainer}>
            <button
                style={styles.volverButton}
                onClick={onClose}
                onMouseOver={(e) =>
                (e.currentTarget.style.backgroundColor = styles.volverHover.backgroundColor)
                }
                onMouseOut={(e) =>
                (e.currentTarget.style.backgroundColor = styles.volverButton.backgroundColor)
                }
            >
                Volver
            </button>
            <button
                style={styles.salirButton}
                onClick={onConfirm}
                onMouseOver={(e) =>
                (e.currentTarget.style.backgroundColor = styles.salirHover.backgroundColor)
                }
                onMouseOut={(e) =>
                (e.currentTarget.style.backgroundColor = styles.salirButton.backgroundColor)
                }
            >
                Sí, salir
            </button>
            </div>
        </div>
        </div>
    );
}

export default ModalConfirmar